module.exports = __webpack_public_path__ + "img/33_15.147d0b38.png";